/**
 * Lib.Common: v-markdown directive
 *
 * Populate element content from Markdown string.
 */


import $markdown from '../prototype/markdown';


function bind(el, binding) {
    el.innerHTML = $markdown.toHTML(
        binding.value,
        binding.modifiers._blank ? { target: '_blank' } : {});
}

function unbind(el) {
    el.innerHTML = '';
}

export default {
    name: 'markdown',
    directive: {
        bind,
        unbind,
        update: bind
    }
};
